import { useCallback, useContext } from "react";
import useApi from "./useApi";
import { AppContext, StationContext } from "contexts";
import { getProductsApi } from "apis";

const useProducts = ({ withStationCode, ...props }) => {
  const { allProducts, setAllProducts } = useContext(AppContext);
  const { station } = useContext(StationContext);

  const getAllProducts = useApi({
    api: getProductsApi,
    key: props?.key,
  });

  const fetch = useCallback(
    async (props) => {
      const res = await getAllProducts?.request(
        {
          page: 1,
          perPage: 1000,
          stationCode: withStationCode ? station.stationCode : undefined,
          ...props?.params,
        },
        () => 0,
        { useLoader: true }
      );

      const products = res.products;
      if (props?.filterResult && typeof props?.filterResult === "function") {
        setAllProducts(props.filterResult(products));
      } else {
        setAllProducts(products);
      }

      return products;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    fetch,
    allProducts,
    loading: getAllProducts.loading,
    setAllProducts,
  };
};

export default useProducts;
